export const PASSING_GRADE = 75;

// Letter grade and remark (descriptor) for a transmuted grade, highest band first.
// `tone` is the badge colour used wherever the remark is shown.
export const GRADE_SCALE = [
  { min: 90, letter: 'A', remark: 'Advancing', tone: 'bg-green-50 text-green-600' },
  { min: 80, letter: 'B', remark: 'Benchmarking', tone: 'bg-green-50 text-green-600' },
  { min: 75, letter: 'C', remark: 'Connecting', tone: 'bg-blue-50 text-blue-600' },
  { min: 65, letter: 'D', remark: 'Developing', tone: 'bg-amber-50 text-amber-600' },
  { min: 0, letter: 'E', remark: 'Emerging', tone: 'bg-red-50 text-red-600' },
];

// Returns null when there is no grade yet.
export function getGradeBand(grade) {
  if (grade == null) return null;
  return GRADE_SCALE.find((band) => grade >= band.min) ?? null;
}
